/* NORD PREMIUM — header-verfijning bij scrollen */
(function () {
  'use strict';
  var lastState = false;
  var ticking = false;

  function update() {
    var scrolled = window.scrollY > 12;
    if (scrolled !== lastState) {
      document.body.classList.toggle('nord-scrolled', scrolled);
      lastState = scrolled;
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
